import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import { cn } from '@/utils';

interface BannerItem {
  image?: string;
  type?: string;
}

interface BannerSliderProps {
  banners?: BannerItem[];
  className?: string;
  isLoading?: boolean;
}

export const BannerSlider: React.FC<BannerSliderProps> = ({ banners, className, isLoading }) => {
  const [imagesLoaded, setImagesLoaded] = useState<Record<number, boolean>>({});

  const allLoaded =
    Array.isArray(banners) && banners.length > 0 && banners.every((_, idx) => imagesLoaded[idx]);

  // Show skeleton while data is still fetching OR while images haven't loaded yet
  const showSkeleton = isLoading || !allLoaded;

  return (
    <div className={cn('relative animate-fade-in', className)}>
      <button className="banner-prev rotate-90 absolute left-3 top-1/2 z-10 -translate-y-1/2">
        <i className="icon-arrow-down text-[1.5rem] opacity-70" />
      </button>

      <button className="banner-next -rotate-90 absolute right-3 top-1/2 z-10 -translate-y-1/2 text-white">
        <i className="icon-arrow-down text-[1.5rem] opacity-70" />
      </button>
      {/* ── Slider ── always rendered so images can preload; hidden until ready */}
      {Array.isArray(banners) && banners.length > 0 && (
        <Swiper
          modules={[Autoplay, Navigation]}
          navigation={{
            prevEl: '.banner-prev',
            nextEl: '.banner-next',
          }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
          }}
          loop
          className="w-full h-full py-2 px-3 "
        >
          {banners.map((banner, idx) => (
            <SwiperSlide key={`${banner.image}-${idx}`}>
              <img
                src={banner.image}
                alt={banner.type}
                className="w-full h-full object-fill rounded-xl"
                onLoad={() => setImagesLoaded((prev) => ({ ...prev, [idx]: true }))}
                onError={() => setImagesLoaded((prev) => ({ ...prev, [idx]: true }))}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      )}
    </div>
  );
};
